import times from "lodash/times";

import { StyledPlaceholder } from "@vega-core/components/Loaders/StyledPlaceholder";

type Props = {
  columnsNumber?: number;
};

export const RowsLoading = ({ columnsNumber = 3 }: Props) => (
  <tbody className="bg-dark-gray">
    {times(7, (i) => (
      <tr className="defaultTransition" key={i + 1}>
        {times(columnsNumber, (c) => (
          <td className="p-5" key={i + c}>
            <StyledPlaceholder className="w-full h-8" />
          </td>
        ))}
      </tr>
    ))}
  </tbody>
);
